<template>
  <div class="humiture_device-container">
    <div class="display-flex top-padding">
      <div class="select-type-container">
        <span>选择类型：</span>
        <el-select placeholder="请选择类型" filterable size="mini" @change="changeType" v-model="defaultForm.typeId">
          <el-option :key="item.id" :label="item.cnName" :value="item.engName" v-for="item in typeList">
          </el-option>
        </el-select>
      </div>
      <div>
        <span v-if="defaultForm.typeId!== 'PM_THC' && defaultForm.typeId !== 'PM_BMU' && defaultForm.typeId !== '变压器温控' && defaultForm.typeId !== '高压综保' && defaultForm.typeId !== 'PM_GGDS'" type="primary" style="cursor: pointer; color: #299bff;font-size: 14px;"  @click="handlePointSelect">测点选择</span>
      </div>
    </div>
    
    <!-- 温湿度（三种设备类型：热通道温湿度、冷通道温湿度、普通温湿度） -->
    <el-table v-if="defaultForm.typeId === 'PM_THC'" class="margin-top-20 device-table" :data="tableData" :border="false"  :show-header="false" :span-method="arraySpanMethod" key="PM_THC">
      <el-table-column label="设备名称" width="150">
        <template slot-scope="scope">
          <div v-if="treeData.length > 0" class="center-text full-width">
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      
      <el-table-column label="热通道温湿度">
        <template slot-scope="scope">
          <div v-if="getDisplayDevices(scope.row.children, scope.$index, 'hot').length === 0 && 
                    getDisplayDevices(scope.row.children, scope.$index, 'cold').length === 0 && 
                    getDisplayDevices(scope.row.children, scope.$index, 'normal').length === 0"
               class="no-device-message">
            该空间没有温湿度设备
          </div>
          <div v-else class="flex-wrap-container">
            <div v-for="(item, index) in getDisplayDevices(scope.row.children, scope.$index, 'hot')" 
                :key="item.id || 'hot-' + item.name + '-' + index" class="item device-item">
              <span class="device-name" style="color: #fff;">{{ item.name }}</span>
              <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                class="data-container" :class="{ 'error-status': item.status !== 0 }">
                <div style="display: flex;align-items: center;">
                  <div style="padding: 0px 5px;">
                    <img style="width: 24px;" :src="item.status !== 0 ? require('@/assets/images/humiture_device/humitureHot2.png') : require('@/assets/images/humiture_device/humitureHot1.png')" alt="" srcset="">
                  </div>
                  <div style="padding: 0px 5px;"
                    :style="{ borderLeft: item.status !== 0 ? '1px solid rgba(255, 2, 0, 0.3)' : '1px solid #299bff4d' }">
                    <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList)" 
                        :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                      <span v-if="elem.pointName">{{ elem.pointValueName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>暂无数据</div>
            </div>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column label="冷通道温湿度">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in getDisplayDevices(scope.row.children, scope.$index, 'cold')" 
                :key="item.id || 'cold-' + item.name + '-' + index" class="item device-item">
              <span class="device-name" style="color: #fff;">{{ item.name }}</span>
              <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                class="data-container" :class="{ 'error-status': item.status !== 0 }">
                <div style="display: flex;align-items: center;">
                  <div style="padding: 0px 5px;">
                    <img style="width: 24px;" :src="item.status !== 0 ? require('@/assets/images/humiture_device/humitureCold2.png') : require('@/assets/images/humiture_device/humitureCold1.png')" alt="" srcset="">
                  </div>
                  <div style="padding: 0px 5px;"
                    :style="{ borderLeft: item.status !== 0 ? '1px solid rgba(255, 2, 0, 0.3)' : '1px solid #299bff4d' }">
                    <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList)" 
                        :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                      <span v-if="elem.pointName">{{ elem.pointValueName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>暂无数据</div>
            </div>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column label="普通温湿度">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in getDisplayDevices(scope.row.children, scope.$index, 'normal')" 
                :key="item.id || 'normal-' + item.name + '-' + index" class="item device-item">
              <span class="device-name" style="color: #fff;">{{ item.name }}</span>
              <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                class="data-container" :class="{ 'error-status': item.status !== 0 }">
                <div style="display: flex;align-items: center;">
                  <div style="padding: 0px 5px;">
                    <img style="width: 24px;" :src="item.status !== 0 ? require('@/assets/images/humiture_device/humiture2.png') : require('@/assets/images/humiture_device/humiture1.png')" alt="" srcset="">
                  </div>
                  <div style="padding: 0px 5px;"
                    :style="{ borderLeft: item.status !== 0 ? '1px solid rgba(255, 2, 0, 0.3)' : '1px solid #299bff4d' }">
                    <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList)" 
                        :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                      <span v-if="elem.pointName">{{ elem.pointValueName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>暂无数据</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 电池组类型（PM_BMU） -->
    <el-table v-else-if="defaultForm.typeId === 'PM_BMU'" class="margin-top-20 device-table" :show-header="false" :data="tableData" :border="false" key="PM_BMU">
      <el-table-column label="设备名称" width="150">
        <template slot-scope="scope">
          <div v-if="treeData.length > 0" class="center-text full-width">
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="设备列表">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in scope.row.children" :key="item.id || 'device-' + item.name + '-' + index" 
                class="item device-item" style="flex-direction: row;">
              <div style="display: flex;align-items: center;">
                <img style="width: 26px;" :src="item.status !== 0 ? require('@/assets/images/humiture_device/battery1.png') : require('@/assets/images/humiture_device/battery2.png')" alt="" srcset="">
              </div>
              <div style="width: 100%;margin-left: 6px;display:flex;flex-direction: column;justify-content: space-evenly">
                <div class="device-name" style="text-align: left;width: 100%;color: #fff;">{{ item.name }}</div>
                <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                  class="data-container" style="border: none;">
                  <!-- 只显示pointName为"组电压"的测点 -->
                  <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList).filter(point => point.pointName === '组电压')" 
                      :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                    <span v-if="elem.pointName"><span style="color: #CCCFD3;">{{ elem.pointName }}：</span>{{ elem.pointValueName }}</span>
                  </div>
                </div>
                <div v-else>暂无数据</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 变压器温控 -->
    <el-table v-else-if="defaultForm.typeId === '变压器温控'" class="margin-top-20 device-table" :show-header="false" :data="tableData" :border="false" key="变压器温控">
      <el-table-column label="设备名称" width="150">
        <template slot-scope="scope">
          <div v-if="treeData.length > 0" class="center-text full-width">
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="设备列表">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in scope.row.children" :key="item.id || 'device-' + item.name + '-' + index" 
                class="item device-item" style="flex-direction: row;">
              <div style="display: flex;flex-direction: column;align-items: center; min-width: 100px;">
              <img style="width: 70px;margin-bottom: 10px;" :src="item.status !== 0 ? require('@/assets/images/humiture_device/transformer1.png') : require('@/assets/images/humiture_device/transformer2.png')" alt="" srcset="">
              <span class="device-name" style="color: #fff;">{{ item.name }}</span>
              </div>
              <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                class="data-container" style="display: flex;align-items: center;border: none;padding-bottom: 23px;">
                <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList)" 
                    :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                  <span v-if="elem.pointName" style="margin: 0px 10px;">{{ elem.pointName }}：{{ elem.pointValueName }}</span>
                </div>
              </div>
              <div v-else>暂无数据</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 精密配电柜 （PM_GGDS） -->
    <el-table v-else-if="defaultForm.typeId === 'PM_GGDS'" class="margin-top-20 device-table" :show-header="false" :data="tableData" :border="false" key="PM_GGDS">
      <el-table-column label="设备名称" width="150">
        <template slot-scope="scope">
          <div v-if="treeData.length > 0" class="center-text full-width">
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="设备列表">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in scope.row.children" :key="item.id || 'device-' + item.name + '-' + index" 
                class="item device-item" style="flex-direction: row;min-width: 245px;">
              <div style="display: flex;align-items: center;">
                <img style="width: 36px;"
                  :src="item.status !== 0 ? require('@/assets/images/humiture_device/cabinet1.png') : require('@/assets/images/humiture_device/cabinet2.png')"
                  alt="" srcset="">
              </div>
              <div
                style="width: 100%;margin-left: 6px;display:flex;flex-direction: column;justify-content: space-evenly">
                <div class="device-name" style="text-align: center;width: 100%;color: #fff;">{{ item.name }}</div>
                <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                  class="data-container" style="border: none;">
                  <div class="flex-column">
                    <span v-if="calculatePhaseLoadRate(item, 'A相电流')">
                      <span style="color: #CCCFD3;">A相负载率：</span>{{ calculatePhaseLoadRate(item, 'A相电流') }}
                    </span>
                    <span v-if="calculatePhaseLoadRate(item, 'B相电流')">
                      <span style="color: #CCCFD3;">B相负载率：</span>{{ calculatePhaseLoadRate(item, 'B相电流') }}
                    </span>
                    <span v-if="calculatePhaseLoadRate(item, 'C相电流')">
                      <span style="color: #CCCFD3;">C相负载率：</span>{{ calculatePhaseLoadRate(item, 'C相电流') }}
                    </span>
                  </div>
                </div>
                <div v-else>暂无数据</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 变压器 -->
    <el-table v-else-if="defaultForm.typeId === '高压综保'" class="margin-top-20 device-table" :show-header="false" :data="tableData" :border="false" key="高压综保">
      <el-table-column label="设备名称" width="150">
        <template slot-scope="scope">
          <div v-if="treeData.length > 0" class="center-text full-width">
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="设备列表">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in scope.row.children" :key="item.id || 'device-' + item.name + '-' + index" 
                class="item device-item" style="flex-direction: row;">
              <div>
                <div class="device-name" style="color: #fff;font-size: 14px;margin-bottom: 16px;">{{ item.name }}</div>
                <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0"
                  class="data-container" style="border: none;">
                  <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList)" 
                      :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                    <span v-if="elem.pointName && elem.pointName !== 'YX3（开关合位）'"><span style="color: #CCCFD3;">{{ elem.pointName }}：</span>{{
                      elem.pointValueName }}</span>
                    <span v-if="elem.pointName === 'YX3（开关合位）'" v-show="false">
                    </span>
                  </div>
                </div>
                <div v-else>暂无数据</div>
              </div>
              <div>
                <img style="width: 137px;margin-left: 10px;" 
                     :src="getDeviceSwitchStatus(item) ? require('@/assets/images/humiture_device/voltage1.png') : require('@/assets/images/humiture_device/voltage2.png')" 
                     alt="" srcset="">
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 默认设备列表 -->
    <el-table v-else class="margin-top-20 device-table" :show-header="false" :data="tableData" :border="false" key="默认设备列表">
      <el-table-column label="设备名称" width="150">
        <template slot-scope="scope">
          <div v-if="treeData.length > 0" class="center-text full-width">
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="设备列表">
        <template slot-scope="scope">
          <div class="flex-wrap-container">
            <div v-for="(item, index) in scope.row.children" style="border: 1px solid #299bff4d;    margin: 20px;
    padding: 10px;text-align: center;" :key="item.id || 'device-' + item.name + '-' + index" 
                 :class="{'error-status': item.status !== 0}">
              <span class="device-name">{{ item.name }}</span>
              <div v-if="item.deviceMeasuringPointHistoryList && item.deviceMeasuringPointHistoryList.length > 0" 
                   class="data-container" style="border: none;overflow-y: auto;">
                <div v-for="(elem, key) in filterMeasuringPoints(item.deviceMeasuringPointHistoryList)" 
                    :key="elem.pointCode || 'point-' + elem.pointName + '-' + key" class="flex-column">
                  <span v-if="elem.pointName">{{ elem.pointName }}：{{ elem.pointValueName }}</span>
                </div>
              </div>
              <div v-else>暂无数据</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 添加测点选择弹窗 - 优化排版 -->
    <el-dialog
      title="测点选择"
      :visible.sync="pointSelectVisible"
      width="550px"
      custom-class="point-select-dialog"
    >
      <div class="point-select-container">
        <div v-if="availablePoints.length === 0" class="no-points">
          暂无可选测点
        </div>
        <div v-else>
          <div class="select-all-header">
            <el-checkbox 
              v-model="isAllSelected"
              @change="handleSelectAllChange"
              class="select-all-checkbox"
            >
              全选
            </el-checkbox>
            
            <el-input
              v-model="pointSearchKeyword"
              placeholder="输入关键字搜索测点"
              size="small"
              suffix-icon="el-icon-search"
              clearable
              class="point-search-input"
            ></el-input>
          </div>
          
          <el-divider></el-divider>
          
          <div class="point-checkbox-grid">
            <el-checkbox-group v-model="selectedPointTypes">
              <el-checkbox 
                v-for="point in filteredPoints" 
                :key="point.code" 
                :label="point.code"
                class="point-checkbox-item"
              >
                {{ point.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pointSelectVisible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="savePointSelection" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDeviceCategoryDetailList } from "@/network/device-category";
import { getSpaceTreeData } from "@/network/space-info";
import { getDeviceCategoryList, getDeviceCategoryDetailListFilter } from "@/network/device-category";

export default {
  name: "HumitureDevice",
  data() {
    return {
      deviceCategoryList: [],
      typeList: [],
      defaultForm: {
        typeId: "PM_THC",
      },
      treeData: [],
      tableData: [],
      loading: false,
      pointSelectVisible: false,
      selectedPointTypes: [],
      availablePoints: [],
      pointSearchKeyword: '',
    };
  },
  created() {
    const time = 5000;
    const humitureDeviceGetData = "humitureDeviceGetData:" + time;
    this.$store.dispatch("addIntervalObj", {
      [humitureDeviceGetData]: this.humitureDeviceGetData,
    });
    
    this.loadPointSelectionFromStorage();
  },
  mounted() {
    this.humitureDeviceGetData();
  },
    destroyed() {
    this.$store.dispatch('removeIntervalObj', 'humitureDeviceGetData')
  },
  methods: {
    getClassifiedDeviceCategory(type) {
      let typeList = [];
      
      if (type === "PM_THC") {
        typeList = ["PM_THC", "PM_HOTTHC", "PM_CLODTHC"];
      } else if (type === "高压综保") {
        typeList = ["PM_Electricity"];
      }  else if (type === "变压器温控") {
        typeList =  ["PM_Electricity"];
      } else {
        typeList = [type];
      }
      if (typeList[0] === "PM_Electricity" && type === "高压综保") {
        getDeviceCategoryDetailListFilter({
          typeList: ["PM_Electricity"],
          modelList: ["高压综保", "科林高压表"]
        }).then((res) => {
          // 过滤设备测点
          res.data.forEach(device => {
            if (device.modelCnName === "科林高压表" && device.deviceMeasuringPointHistoryList) {
              device.deviceMeasuringPointHistoryList = device.deviceMeasuringPointHistoryList.filter(point => 
                point.pointName === "A相电压" || 
                point.pointName === "B相电压" || 
                point.pointName === "C相电压" || 
                point.pointName === "A相电流" || 
                point.pointName === "B相电流" || 
                point.pointName === "C相电流" || 
                point.pointName === "有功功率"
              );
            } else if (device.modelCnName === "高压综保" && device.deviceMeasuringPointHistoryList) {
              device.deviceMeasuringPointHistoryList = device.deviceMeasuringPointHistoryList.filter(point => 
                point.pointName === "YX3（开关合位）"
              );
            }
          });
          
          // 1. 先按空间ID分组
          const spaceGroups = {};
          res.data.forEach(device => {
            if (!spaceGroups[device.spaceId]) {
              spaceGroups[device.spaceId] = {
                spaceName: device.spaceName,
                devices: {}
              };
            }
            
            // 2. 提取设备名称的基础部分（在第二个"-"之前的内容）
            // 例如从"1层低压A配电室-1T1-AH2-ZB"中提取"1层低压A配电室-1T1"
            let baseNameParts = device.name.split('-');
            let baseName;
            
            if (baseNameParts.length >= 2) {
              // 取前两部分组成基本名称
              baseName = baseNameParts.slice(0, 2).join('-');
            } else {
              // 如果格式不符合预期，使用完整名称
              baseName = device.name;
            }
            
            // 3. 在空间内按基础名称分组
            if (!spaceGroups[device.spaceId].devices[baseName]) {
              spaceGroups[device.spaceId].devices[baseName] = [];
            }
            
            // 过滤掉 pointCode === 'state0' 的测点
            if (device.deviceMeasuringPointHistoryList && device.deviceMeasuringPointHistoryList.length) {
              device.deviceMeasuringPointHistoryList = device.deviceMeasuringPointHistoryList.filter(
                point => point.pointCode !== 'state0'
              );
            }
            
            spaceGroups[device.spaceId].devices[baseName].push(device);
          });
          
          // 4. 合并同一基础名称下的设备
          const obj = {};
          for (const spaceId in spaceGroups) {
            const spaceName = spaceGroups[spaceId].spaceName;
            if (!obj[spaceName]) {
              obj[spaceName] = [];
            }
            
            for (const baseName in spaceGroups[spaceId].devices) {
              const deviceGroup = spaceGroups[spaceId].devices[baseName];
              
              // 如果同一基础名称有多个设备，需要合并它们
              if (deviceGroup.length > 1) {
                // 找出高压综保和科林高压表设备
                const highVoltageProtectionDevice = deviceGroup.find(d => d.modelCnName === "高压综保");
                const transformerTempControlDevice = deviceGroup.find(d => d.modelCnName === "科林高压表");
                
                if (highVoltageProtectionDevice && transformerTempControlDevice) {
                  // 创建合并后的设备对象，基于高压综保设备
                  const mergedDevice = JSON.parse(JSON.stringify(highVoltageProtectionDevice));
                  
                  // 修改显示名称为基础名称
                  mergedDevice.name = baseName;
                  
                  // 合并测点列表
                  if (transformerTempControlDevice.deviceMeasuringPointHistoryList && transformerTempControlDevice.deviceMeasuringPointHistoryList.length) {
                    if (!mergedDevice.deviceMeasuringPointHistoryList) {
                      mergedDevice.deviceMeasuringPointHistoryList = [];
                    }
                    
                    mergedDevice.deviceMeasuringPointHistoryList = [
                      ...mergedDevice.deviceMeasuringPointHistoryList,
                      ...transformerTempControlDevice.deviceMeasuringPointHistoryList
                    ];
                  }
                  
                  // 添加标记表示这是合并的设备
                  mergedDevice.isMerged = true;
                  mergedDevice.originalDevices = [
                    {
                      name: highVoltageProtectionDevice.name,
                      modelCnName: "高压综保"
                    },
                    {
                      name: transformerTempControlDevice.name,
                      modelCnName: "科林高压表"
                    }
                  ];
                  
                  // 添加合并后的设备
                  obj[spaceName].push(mergedDevice);
                } else {
                  // 如果没有同时找到两种型号，添加所有设备
                  deviceGroup.forEach(device => {
                    obj[spaceName].push(device);
                  });
                }
              } else {
                // 只有一个设备，直接添加
                obj[spaceName].push(deviceGroup[0]);
              }
            }
          }
          
          // 5. 构建最终的表格数据
          const arr = [];
          for (const key in obj) {
            const obj1 = {};
            obj1.id = key;
            obj1.children = obj[key];
            arr.push(obj1);
          }
          
          console.log('处理后的数据:', arr);
          this.tableData = arr;
        });
      } else if (typeList[0] === "PM_Electricity" && type === "变压器温控") {
        getDeviceCategoryDetailListFilter({
          typeList: ["PM_Electricity"],
          modelList: ["变压器温控"]
        }).then((res) => {
          let DATA = res.data ? res.data.map((item) => {
            if (item.deviceMeasuringPointHistoryList) {
              item.deviceMeasuringPointHistoryList = item.deviceMeasuringPointHistoryList.filter(elem => 
                elem.pointName === 'A相温度' || 
                elem.pointName === 'B相温度' || 
                elem.pointName === 'C相温度'
              );
            }
            return item;
          }) : [];
          
          const obj = {};
          function getTreeData(data) {
            data.forEach((item) => {
              DATA.forEach((elem) => {
                if (item.id === elem.spaceId) {
                  if (!obj[elem.spaceName]) {
                    obj[elem.spaceName] = [];
                  }
                  obj[elem.spaceName].push(elem);
                }
              });
              if (item.children) {
                getTreeData(item.children);
              }
            });
          }
          
          getTreeData(this.treeData);
          
          const arr = [];
          for (const key in obj) {
            const obj1 = {};
            obj1.id = key;
            obj1.children = obj[key];
            arr.push(obj1);
          }
          
          this.tableData = arr;
        })
      } else {
        getDeviceCategoryDetailList(typeList).then((res) => {
          let DATA = res.data ? res.data.map((item) => {
            if (item.typeEngName === 'PM_WLD' && item.deviceMeasuringPointHistoryList) {
              item.deviceMeasuringPointHistoryList = item.deviceMeasuringPointHistoryList.filter(elem => elem.pointCode !== 'state0');
            }
            return item;
          }) : [];
          
          const obj = {};
          // 如果是typeEngName ==="PM_Electricity"
          function getTreeData(data) {
            data.forEach((item) => {
              DATA.forEach((elem) => {
                if (item.id === elem.spaceId) {
                  if (!obj[elem.spaceName]) {
                    obj[elem.spaceName] = [];
                  }
                  obj[elem.spaceName].push(elem);
                }
              });
              if (item.children) {
                getTreeData(item.children);
              }
            });
          }
          
          getTreeData(this.treeData);
          
          const arr = [];
          for (const key in obj) {
            const obj1 = {};
            obj1.id = key;
            obj1.children = obj[key];
            arr.push(obj1);
          }
          
          this.tableData = arr;
        });
      }
    },

    async humitureDeviceGetData() {
      this.treeData = (await getSpaceTreeData()).data;
      this.getClassifiedDeviceCategory(this.defaultForm.typeId);
      this.getDeviceCategoryList();
    },

    getDeviceCategoryList() {
      getDeviceCategoryList().then((res) => {
        if (res.code === 0) {
          this.typeList = res.data.filter(item => 
            item.engName !== 'PM_HOTTHC' && item.engName !== 'PM_CLODTHC');
            // 单独添加高压综保和变压器温控用一个类型PM_Electricity
            this.typeList.push({
              id: '高压综保',
              cnName: '高压综保',
              engName: '高压综保'
            }, {
              id: '变压器温控',
              cnName: '变压器温控',
              engName: '变压器温控'
            });
        }
      });
    },
    
    getDevicesByType(devices, type) {
      if (!devices || !devices.length) return [];
      
      return devices.filter(device => {
        const deviceName = device.name.toLowerCase();
        const deviceType = device.typeEngName || '';
        
        if (type === 'hot') {
          return deviceType === 'PM_HOTTHC' || 
            deviceName.includes('热') || 
            deviceName.includes('hot') || 
            deviceName.includes('2f-2');
        } else if (type === 'cold') {
          return deviceType === 'PM_CLODTHC' || 
            deviceName.includes('冷') || 
            deviceName.includes('cold') || 
            deviceName.includes('2f-3');
        } else {
          return deviceType === 'PM_THC' && 
            !deviceName.includes('热') && 
            !deviceName.includes('hot') && 
            !deviceName.includes('2f-2') &&
            !deviceName.includes('冷') && 
            !deviceName.includes('cold') && 
            !deviceName.includes('2f-3');
        }
      });
    },
    
    changeType(type) {
      if (!type) {
        this.$message({
          message: '请选择一个设备类型',
          type: 'warning'
        });
        this.defaultForm.typeId = "PM_THC";
        this.getClassifiedDeviceCategory(this.defaultForm.typeId);
      }
      
      // 先清空当前数据
      this.tableData = [];
      
      // 异步获取新数据
      this.$nextTick(() => {
        this.getClassifiedDeviceCategory(type);
        this.loadPointSelectionFromStorage();
      });
    },
    
    handleClose() {
      if (!this.defaultForm.typeId) {
        this.$message({
          message: '请选择一个设备类型',
          type: 'warning'
        });
        this.defaultForm.typeId = "PM_THC";
        this.getClassifiedDeviceCategory(this.defaultForm.typeId);
      }
    },

    hasDeviceType(type) {
      if (!this.tableData || !this.tableData.length) return false;
      
      return this.tableData.some(row => {
        if (!row.children || !row.children.length) return false;
        
        return this.getDevicesByType(row.children, type).length > 0;
      });
    },
    handlePointSelect() {
      this.collectAvailablePoints();
      this.pointSelectVisible = true;
    },
    
    collectAvailablePoints() {
      const pointMap = new Map();
      
      if (this.tableData && this.tableData.length) {
        this.tableData.forEach(row => {
          if (row.children && row.children.length) {
            row.children.forEach(device => {
              if (device.deviceMeasuringPointHistoryList && device.deviceMeasuringPointHistoryList.length) {
                device.deviceMeasuringPointHistoryList.forEach(point => {
                  if (point.pointCode && point.pointName) {
                    pointMap.set(point.pointCode, {
                      code: point.pointCode,
                      name: point.pointName
                    });
                  }
                });
              }
            });
          }
        });
      }
      
      this.availablePoints = Array.from(pointMap.values());
    },
    
    savePointSelection() {
      try {
        localStorage.setItem('humitureDevicePointSelection', JSON.stringify({
          deviceType: this.defaultForm.typeId,
          selectedPoints: this.selectedPointTypes
        }));
        
        this.$message.success('测点选择已保存');
        this.pointSelectVisible = false;
      } catch (e) {
        console.error('保存测点选择失败:', e);
        this.$message.error('保存测点选择失败');
      }
    },
    
    loadPointSelectionFromStorage() {
      try {
        const savedSelection = localStorage.getItem('humitureDevicePointSelection');
        if (savedSelection) {
          const data = JSON.parse(savedSelection);
          if (data.deviceType === this.defaultForm.typeId) {
            this.selectedPointTypes = data.selectedPoints || [];
          } else {
            this.selectedPointTypes = [];
          }
        }
      } catch (e) {
        console.error('加载测点选择失败:', e);
        this.selectedPointTypes = [];
      }
    },
    
    filterMeasuringPoints(pointList) {
      if (!pointList || !pointList.length) return [];
      
      if (!this.selectedPointTypes.length) return pointList;
      
      return pointList.filter(point => this.selectedPointTypes.includes(point.pointCode));
    },
    
    handleSelectAllChange(val) {
      if (val) {
        this.selectedPointTypes = this.availablePoints.map(point => point.code);
      } else {
        this.selectedPointTypes = [];
      }
    },
    
    calculateLoadRate(pointList) {
      console.log(pointList, 'pointList');
      if (!pointList || !pointList.length) return '0%';
      
      const actualCurrentPoint = pointList.find(point => point.pointName === '实际负载电流');
      const ratedCurrentPoint = pointList.find(point => point.pointName === '额定电流');
      
      if (!actualCurrentPoint || !ratedCurrentPoint) return '无数据';
      
      const actualCurrent = parseFloat(actualCurrentPoint.pointValue);
      const ratedCurrent = parseFloat(ratedCurrentPoint.pointValue);
      
      if (isNaN(actualCurrent) || isNaN(ratedCurrent) || ratedCurrent === 0) return '计算错误';
      
      const loadRate = (actualCurrent / ratedCurrent) * 100;
      return loadRate.toFixed(2) + '%';
    },
    
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 第一列(设备名称)不做处理
      console.log(column, rowIndex);
      if (columnIndex === 0) return;
      
      // 获取该空间下各类型设备数量
      const hotDevices = this.getDevicesByType(row.children, 'hot');
      const coldDevices = this.getDevicesByType(row.children, 'cold');
      const normalDevices = this.getDevicesByType(row.children, 'normal');
      
      // 判断各类型设备是否存在
      const hasHot = hotDevices.length > 0;
      const hasCold = coldDevices.length > 0;
      const hasNormal = normalDevices.length > 0;
      
      // 处理不同情况的单元格合并
      
      // 情况1: 三种类型都有设备，不需要合并
      if (hasHot && hasCold && hasNormal) {
        return { colspan: 1, rowspan: 1 };
      }
      
      // 情况2: 只有热通道设备
      if (hasHot && !hasCold && !hasNormal) {
        return columnIndex === 1 ? { colspan: 3, rowspan: 1 } : { colspan: 0, rowspan: 0 };
      }
      
      // 情况3: 只有冷通道设备
      if (!hasHot && hasCold && !hasNormal) {
        if (columnIndex === 1) return { colspan: 0, rowspan: 0 };
        if (columnIndex === 2) return { colspan: 3, rowspan: 1 };
        return { colspan: 0, rowspan: 0 };
      }
      
      // 情况4: 只有普通温湿度设备
      if (!hasHot && !hasCold && hasNormal) {
        if (columnIndex === 1 || columnIndex === 2) return { colspan: 0, rowspan: 0 };
        if (columnIndex === 3) return { colspan: 3, rowspan: 1 };
      }
      
      // 情况5: 有热通道和冷通道，没有普通
      if (hasHot && hasCold && !hasNormal) {
        if (columnIndex === 1) return { colspan: 1, rowspan: 1 };
        if (columnIndex === 2) return { colspan: 2, rowspan: 1 };
        return { colspan: 0, rowspan: 0 };
      }
      
      // 情况6: 有热通道和普通，没有冷通道
      if (hasHot && !hasCold && hasNormal) {
        if (columnIndex === 1) return { colspan: 2, rowspan: 1 };
        if (columnIndex === 2) return { colspan: 0, rowspan: 0 };
        if (columnIndex === 3) return { colspan: 1, rowspan: 1 };
      }
      
      // 情况7: 有冷通道和普通，没有热通道
      if (!hasHot && hasCold && hasNormal) {
        if (columnIndex === 1) return { colspan: 0, rowspan: 0 };
        if (columnIndex === 2) return { colspan: 1, rowspan: 1 };
        if (columnIndex === 3) return { colspan: 1, rowspan: 1 };
      }
      
      // 情况8: 三种类型都没有设备
      if (!hasHot && !hasCold && !hasNormal) {
        return columnIndex === 1 ? { colspan: 3, rowspan: 1 } : { colspan: 0, rowspan: 0 };
      }
      
      return { colspan: 1, rowspan: 1 };
    },
    
    // 修改设备显示方法，处理合并单元格的情况
    getDisplayDevices(devices, rowIndex, colTypes) {
      if (!devices || !devices.length) return [];
      
      // 获取该空间下各类型设备
      const hotDevices = this.getDevicesByType(devices, 'hot');
      const coldDevices = this.getDevicesByType(devices, 'cold');
      const normalDevices = this.getDevicesByType(devices, 'normal');
      
      // 判断各类型设备是否存在
      const hasHot = hotDevices.length > 0;
      const hasCold = coldDevices.length > 0;
      const hasNormal = normalDevices.length > 0;
      
      let resultDevices = [];
      
      // 根据单元格合并逻辑返回对应设备
      if (colTypes === 'hot') {
        // 热通道列
        if (!hasHot && !hasCold && !hasNormal) {
          return []; // 没有任何设备
        }
        
        if (hasHot && !hasCold && !hasNormal) {
          resultDevices = [...hotDevices]; // 只有热通道设备，且显示在热通道列
        } else if (hasHot) {
          resultDevices = hotDevices; // 有热通道设备
        } else {
          return []; // 其他情况不在热通道列显示
        }
      }
      
      else if (colTypes === 'cold') {
        // 冷通道列
        if (!hasHot && hasCold && !hasNormal) {
          resultDevices = [...coldDevices]; // 只有冷通道设备，且显示在冷通道列
        } else if (hasCold) {
          resultDevices = coldDevices; // 有冷通道设备
        } else {
          return []; // 其他情况不在冷通道列显示
        }
      }
      
      else if (colTypes === 'normal') {
        // 普通温湿度列
        if (!hasHot && !hasCold && hasNormal) {
          resultDevices = [...normalDevices]; // 只有普通温湿度设备，且显示在普通温湿度列
        } else if (hasNormal) {
          resultDevices = normalDevices; // 有普通温湿度设备
        } else {
          return []; // 其他情况不在普通温湿度列显示
        }
      }
      
      // 自然排序算法，处理数字和字母混合的情况
      return resultDevices.sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';
        
        // 将字符串分割成字母和数字部分进行比较
        const regex = /(\d+|\D+)/g;
        const partsA = nameA.match(regex) || [];
        const partsB = nameB.match(regex) || [];
        
        // 逐部分比较
        for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
          const partA = partsA[i];
          const partB = partsB[i];
          
          // 判断是否为数字部分
          const isNumA = !isNaN(partA);
          const isNumB = !isNaN(partB);
          
          if (isNumA && isNumB) {
            // 两者都是数字，按数值比较
            const diff = parseInt(partA) - parseInt(partB);
            if (diff !== 0) return diff;
          } else if (isNumA !== isNumB) {
            // 一个是数字一个是字母，数字在前
            return isNumA ? -1 : 1;
          } else {
            // 两者都是字母，按字母顺序比较
            const diff = partA.localeCompare(partB, 'zh-CN');
            if (diff !== 0) return diff;
          }
        }
        
        // 如果前面部分都相同，较短的名称排在前面
        return partsA.length - partsB.length;
      });
    },
    getDeviceSwitchStatus(device) {
      if (!device.deviceMeasuringPointHistoryList || !device.deviceMeasuringPointHistoryList.length) {
        return false;
      }
      
      // 查找名为"YX3（开关合位）"的测点
      const switchPoint = device.deviceMeasuringPointHistoryList.find(
        point => point.pointName === 'YX3（开关合位）'
      );
      
      if (!switchPoint) {
        return false;
      }
      
      // 判断值是否为"1"或"开"
      return switchPoint.pointValue === 1;
    },
    getPhaseCurrentPoint(pointList, phaseName) {
      if (!pointList || !pointList.length) return null;
      return pointList.find(point => point.pointName === phaseName);
    },
    calculatePhaseLoadRate(item, phaseName) {
      if (!item.deviceMeasuringPointHistoryList || !item.deviceMeasuringPointHistoryList.length) return '';
      
      // 将 note 从 JSON 字符串转换为对象
      let noteObj;
      try {
        noteObj = typeof item.note === 'string' ? JSON.parse(item.note) : item.note;
      } catch (e) {
        return '';
      }
      
      if (!noteObj || !noteObj.rc) return '';
      
      const phasePoint = this.getPhaseCurrentPoint(item.deviceMeasuringPointHistoryList, phaseName);
      if (!phasePoint) return '';
      
      const phaseCurrent = parseFloat(phasePoint.pointValue);
      const ratedCurrent = parseFloat(noteObj.rc);
      
      if (isNaN(phaseCurrent) || isNaN(ratedCurrent) || ratedCurrent === 0) return '';
      
      const loadRate = (phaseCurrent / ratedCurrent) * 100;
      return loadRate.toFixed(2) + '%';
    },
  },
  computed: {
    filteredPoints() {
      if (!this.pointSearchKeyword) {
        return this.availablePoints;
      }
      
      const keyword = this.pointSearchKeyword.toLowerCase();
      return this.availablePoints.filter(point => 
        point.name.toLowerCase().includes(keyword) || 
        point.code.toLowerCase().includes(keyword)
      );
    },
    isAllSelected: {
      get() {
        if (this.availablePoints.length === 0) return false;
        return this.selectedPointTypes.length === this.availablePoints.length;
      },
      set(value) {
        return value;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.humiture_device-container {
padding: 0px 20px 30px 20px;
  height: 100%;
  width: 100%;

  ::v-deep .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #299bff4d;
  }

  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  ::v-deep .el-table td.el-table__cell {
    border-top: 1px solid #299bff4d;
  }

  .item:hover {
    background-color: rgba(41, 155, 255, 0.2) !important;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .top-padding {
    padding: 35px 0 0 0;
    display: flex;
    justify-content: space-between;
  }

  .select-type-container {
    flex-basis: 20%;
  }

  .device-table {
    width: 100%;
    overflow: auto;
    max-height: calc(85%);
  }

  .center-text {
    text-align: center;
  }

  .full-width {
    width: 100%;
  }

  .flex-wrap-container {
    display: flex;
    flex-wrap: wrap;
  }

  .device-item {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 10px 15px;
    margin: 10px 15px;
    justify-content: flex-start;
  }

  .error-status {
    background: rgba(255, 2, 0, 0.2);
    border: 1px solid rgba(255, 2, 0, 0.3) !important;
  }

  .device-name {
    color: #07e6f8;
  }

  .data-container {
    max-height: 200px;
    border: 1px solid #299bff4d;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
  }
}

.point-select-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  
  .no-points {
    text-align: center;
    padding: 30px 0;
    color: #909399;
    font-size: 14px;
  }
}

.select-all-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
  margin-bottom: 10px;
}

.select-all-checkbox {
  font-weight: bold;
}

.point-search-input {
  width: 220px;
}

.point-checkbox-grid {
  display: flex;
  padding: 10px 0;
  
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  
  .point-checkbox-item {
    width: calc(50% - 10px);
    margin: 5px;
    padding: 8px 10px;
    border-radius: 4px;
    transition: background-color 0.2s;
    
    &:hover {
      background-color: rgba(41, 155, 255, 0.1);
    }
  }
}

::v-deep .point-select-dialog {
  background: rgba(4, 22, 38, 0.95);
  border-radius: 6px;
  
  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  }
  
  .el-dialog__title {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
  }
  
  .el-dialog__body {
    padding: 20px;
    color: #ffffff;
  }
  
  .el-dialog__footer {
    padding: 10px 20px 15px;
    border-top: 1px solid rgba(41, 155, 255, 0.2);
  }
  
  .el-checkbox__label {
    color: #ffffff;
    font-size: 14px;
  }
  
  .el-divider {
    background-color: rgba(41, 155, 255, 0.3);
    margin: 10px 0;
  }
  
  .el-input__inner {
    background-color: rgba(13, 36, 56, 0.8);
    border: 1px solid rgba(41, 155, 255, 0.3);
    color: white;
  }
  
  .el-input__icon {
    color: rgba(255, 255, 255, 0.7);
  }
}

.no-device-message {
  color: #909399;
  text-align: center;
  padding: 20px 0;
  font-style: italic;
}
</style>
